import React, { useContext } from 'react';
import Cookies from 'js-cookie';
import UserProvider from '../../context/UserContext';

const NavBarKey = () => {
    const Data = useContext(UserProvider.context);
    const userData = Data.user;

    const id = userData.id;
    const avatar = userData.avatar;
    let avatarUrl = ''
    
    if(avatar == null) {
        avatarUrl = 'https://cdn.discordapp.com/app-icons/708966884254547978/f053c129acb0da07a723a667669bd6d2.png'
    }
    else {
         avatarUrl = 'https://cdn.discordapp.com/avatars/'+id+'/'+avatar+'.png'
    }

    return(
        <nav className="navbar navbar-default">
            <div className="navbar-header navbar-user avatar">
                    <img alt="" src={avatarUrl}></img>     
                    <span>{userData.username ? userData.username.toLowerCase() : ""}#{userData.discriminator}</span>
            </div>
            <div className="navbar-right">
                <div className="logout">
                <button className="logout-button-key" onClick={() => {
                        Cookies.remove('user_data', { path: '/', domain: '.infinitbot.com' })
                        Cookies.remove('session', { path: '/', domain: '.infinitbot.com' })
                        window.location.replace('/')
                    }}>
                    <h4>Logout</h4>
                </button>
                </div>
            </div>
           
        </nav>
        
  
    )
};

export default NavBarKey;